import { Provider, Signal, computed } from "@angular/core";
import {
    ATOM_DATE_RANGE_PRESET_LABELS,
    type AtomDateRangePresetLabels,
} from "@atomchat-io/ui-design-system";
import { translateObjectSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "global_dropdown.calendar_filter";

/**
 * Localizes the default `atom-date-range-filter` preset labels (today,
 * yesterday, this week, last 15 days, custom) for every consumer of the
 * component. The DS token defaults to English; here we override it globally
 * with a Transloco-driven signal so the presets follow the active language.
 *
 * Reactive to language switches: `translateObjectSignal` re-emits on lang
 * change, and we map only the preset keys the component reads (ignoring the
 * nested `custom_ranges` entry that shares the same translation object).
 */
export const provideAtomDateRangePresetLabels = (): Provider => ({
    provide: ATOM_DATE_RANGE_PRESET_LABELS,
    useFactory: (): AtomDateRangePresetLabels => {
        const labels = translateObjectSignal(BASE_KEY_PATH) as Signal<
            Record<string, string>
        >;
        return computed(() => {
            const l = labels();
            return {
                today: l.today,
                yesterday: l.yesterday,
                this_week: l.this_week,
                last_15_days: l.last_15_days,
                custom: l.custom,
            };
        });
    },
});
